/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CompanyMeeting
 */
export interface CompanyMeeting {
  /**
   *
   * @type {string}
   * @memberof CompanyMeeting
   */
  companyMeetingId?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyMeeting
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyMeeting
   */
  companyNoteId?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyMeeting
   */
  jamieMeetingId?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyMeeting
   */
  jamieUrl?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyMeeting
   */
  title?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CompanyMeeting
   */
  meetingDate?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof CompanyMeeting
   */
  summaryMarkdown?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyMeeting
   */
  summaryShort?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyMeeting
   */
  transcript?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyMeeting
   */
  participantsJson?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyMeeting
   */
  actionItemsJson?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyMeeting
   */
  rawMeetingJson?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CompanyMeeting
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof CompanyMeeting
   */
  createdBy?: string;
}

/**
 * Check if a given object implements the CompanyMeeting interface.
 */
export function instanceOfCompanyMeeting(
  value: object,
): value is CompanyMeeting {
  return true;
}

export function CompanyMeetingFromJSON(json: any): CompanyMeeting {
  return CompanyMeetingFromJSONTyped(json, false);
}

export function CompanyMeetingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyMeeting {
  if (json == null) {
    return json;
  }
  return {
    companyMeetingId:
      json["companyMeetingId"] == null ? undefined : json["companyMeetingId"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    companyNoteId:
      json["companyNoteId"] == null ? undefined : json["companyNoteId"],
    jamieMeetingId:
      json["jamieMeetingId"] == null ? undefined : json["jamieMeetingId"],
    jamieUrl: json["jamieUrl"] == null ? undefined : json["jamieUrl"],
    title: json["title"] == null ? undefined : json["title"],
    meetingDate: json["meetingDate"] == null ? undefined : json["meetingDate"],
    summaryMarkdown:
      json["summaryMarkdown"] == null ? undefined : json["summaryMarkdown"],
    summaryShort:
      json["summaryShort"] == null ? undefined : json["summaryShort"],
    transcript: json["transcript"] == null ? undefined : json["transcript"],
    participantsJson:
      json["participantsJson"] == null ? undefined : json["participantsJson"],
    actionItemsJson:
      json["actionItemsJson"] == null ? undefined : json["actionItemsJson"],
    rawMeetingJson:
      json["rawMeetingJson"] == null ? undefined : json["rawMeetingJson"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
  };
}

export function CompanyMeetingToJSON(json: any): CompanyMeeting {
  return CompanyMeetingToJSONTyped(json, false);
}

export function CompanyMeetingToJSONTyped(
  value?: CompanyMeeting | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyMeetingId: value["companyMeetingId"],
    companyId: value["companyId"],
    companyNoteId: value["companyNoteId"],
    jamieMeetingId: value["jamieMeetingId"],
    jamieUrl: value["jamieUrl"],
    title: value["title"],
    meetingDate: value["meetingDate"],
    summaryMarkdown: value["summaryMarkdown"],
    summaryShort: value["summaryShort"],
    transcript: value["transcript"],
    participantsJson: value["participantsJson"],
    actionItemsJson: value["actionItemsJson"],
    rawMeetingJson: value["rawMeetingJson"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
  };
}
